import type { AcceptedBet } from '../../../store/slices/bets/types';
import { ChipTypes } from '../../../store/slices/chips/types';

import type { ComputedBet } from './types';

export const getAcceptedBets = (computedBets: ComputedBet[]): AcceptedBet[] => {
  return computedBets.map((bet) => {
    const computedBetObj: AcceptedBet = {
      amount: bet.value,
      betCode: bet.betId,
      errorCode: -1,
      type: bet.type,
    };
    if (bet.type === ChipTypes.FreeChip) {
      computedBetObj.count = bet.count ?? 0;
    }
    return computedBetObj;
  });
};
